// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".th-td-style {\n  vertical-align: middle !important;\n}\n.th1-style {\n  background: #EEEEEE !important;\n  font-weight: 700;\n  width: 100%;\n}\n.th2-style {\n  background: #EEEEEE !important;\n  font-weight: 700;\n  width: 50%;\n}\n.td1-style {\n  width: 8%;\n}\n.td2-style {\n  width: 42%;\n}\n.td3-style {\n  width: 50%;\n}", ""]);
// Exports
module.exports = exports;
